import React from 'react'

const Header = ({ showEdit }) => (
    <thead>
        <tr className="audience-list audience-list--header">
            <th className="audience-list audience-list--audience">Email</th>
            <th className="audience-list audience-list--audience">Name</th>
            <th className="audience-list audience-list--audience">Family Name</th>
            <th className="audience-list audience-list--audience" style={{ width: '200px' }}>
                Role
            </th>
            <th className="audience-list audience-list--size">Is Active</th>
            {showEdit && <th className="audience-list audience-list--edit">Edit</th>}
        </tr>
    </thead>
)

export default Header
